define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../models/UserContext", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, UserContext, LookupDataSources) {
    "use strict";
    var CustomersNotesReport = /** @class */ (function () {
        function CustomersNotesReport() {
            this.rangeBy = ko.observable(1);
            this.filterCustomersNotesReportByStartDate = ko.observable(DateUtils.firstDayOfMonth());
            this.filterCustomersNotesReportByEndDate = ko.observable(DateUtils.lastDayOfMonth());
            this.canExport = ko.observable(UserContext.hasAccess("Admin,CustomersNotesReport.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin,Reports.Admin"));
        }
        CustomersNotesReport.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customers Notes Report");
            tools.ajaxGet({
                url: "/Reports/GetCustomersNotesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.initGrid(data.Data.GridStructures.CustomersNotesReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomersNotesReport.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCustomersNotesReportKendo";
            var columns = gridStructure.columns;
            //add actions column
            if (UserContext.hasAccess("Admin")) {
                var actions = {
                    field: "",
                    width: "100px",
                    template: function (dataItem) {
                        var html = "";
                        html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/Customers/Edit/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i>&nbsp;View</a>");
                        return html;
                    }
                };
                columns.push(actions);
            }
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetCustomersNotesData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.rangeBy = self.rangeBy();
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCustomersNotesReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCustomersNotesReportByEndDate());
                                if (self.multipleNoteCategoriesSelector) {
                                    data.categories = self.multipleNoteCategoriesSelector.value().join(",");
                                }
                                if (self.multipleCustomersSelector) {
                                    data.customers = self.multipleCustomersSelector.value().join(",");
                                }
                                if (self.multipleTagsSelector) {
                                    data.tags = self.multipleTagsSelector.value().join(",");
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#customersNotesReport-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                },
                enableExport: {
                    entityName: "CustomersNotesReport",
                    title: "Customers Notes Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
            var lookupDataSources = new LookupDataSources();
            var tagsDS = lookupDataSources.createLookupDataSource("Tags");
            var categoriesDS = lookupDataSources.createLookupDataSource("NoteCategories");
            var customersDS = lookupDataSources.createLookupDataSource("Customers");
            self.multipleNoteCategoriesSelector = $("#filterByNoteCategoryInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Categories",
                dataTextField: "Text",
                dataValueField: "Id",
                autoClose: false,
                tagMode: "single",
                dataSource: categoriesDS,
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
            self.multipleCustomersSelector = $("#filterByCustomerInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Customers",
                dataTextField: "Text",
                dataValueField: "Id",
                autoClose: false,
                tagMode: "single",
                dataSource: customersDS,
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
            self.multipleTagsSelector = $("#filterByTagInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                placeholder: "All Tags",
                dataTextField: "Text",
                dataValueField: "Id",
                autoClose: false,
                tagMode: "single",
                dataSource: tagsDS,
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    $(window).trigger("resize");
                    self.reportTable.refresh();
                }
            }).data("kendoMultiSelect");
            self.rangeBy.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersNotesReportByStartDate.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersNotesReportByEndDate.subscribe(function () {
                self.reportTable.refresh();
            });
        };
        CustomersNotesReport.prototype.clearFilter = function () {
            var self = this;
            self.filterCustomersNotesReportByStartDate(DateUtils.firstDayOfMonth());
            self.filterCustomersNotesReportByEndDate(DateUtils.lastDayOfMonth());
            self.rangeBy(1);
            self.multipleTagsSelector.value([]);
            self.multipleCustomersSelector.value([]);
            self.multipleNoteCategoriesSelector.value([]);
        };
        CustomersNotesReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return CustomersNotesReport;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/CustomersNotesReportIndex")) {
            log.log("Initialize CustomersNotesReportIndex list");
            $(function () {
                (new CustomersNotesReport()).init();
            });
        }
    }, 0);
    return CustomersNotesReport;
});
//# sourceMappingURL=CustomersNotesReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/customersNotesReport.js
// module id = 260
// module chunks = 2